/**
 * Mixin for datatables
 * Handling expanded rows & pagination
 */
export default {
  data() {
    return {
      expandedRow: null,
      pageSize: 5,
      pageSizes: [5, 10, 25, 50, 100],
      currentPage: 1,
    };
  },
  computed: {
    fromIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    toIndex() {
      const highBound = this.fromIndex + this.pageSize;

      return highBound > this.totalTableData ? this.totalTableData : highBound;
    },
  },
  methods: {
    handleRowClick(row) {
      if (this.expandedRow && this.expandedRow !== row) {
        this.$refs.table.toggleRowExpansion(this.expandedRow, false);
      }
      this.expandedRow = row;
      this.$refs.table.toggleRowExpansion(row);
    },
    handleExpandChange(row, expandedRows) {
      expandedRows.forEach(r => {
        this.$refs.table.toggleRowExpansion(r, r === row);
      });

      this.expandedRow = expandedRows.includes(row) ? row : null;
      
    },
  },
};
